(function () {
  'use strict';

  var root = document.querySelector('[data-uf-floor-advisor]');
  if (!root) return;

  var STORAGE_KEY = 'uf_floor_advisor_dismissed_at';
  var storageDays = 7;
  var mode = root.getAttribute('data-uf-fa-mode') || 'modal';
  var isInline = mode === 'inline';
  var orientBase = root.getAttribute('data-uf-fa-orient') || '/collections/pvc?view=orientatieruimte';

  var patterns = {};
  var scenes = {};
  var matrixUrl = '/collections/pvc?view=uf-advisor-matrix';
  try {
    var cfgNode = root.querySelector('[data-uf-fa-config]');
    if (cfgNode) {
      var cfg = JSON.parse(cfgNode.textContent || '{}');
      patterns = cfg.patterns || {};
      scenes = cfg.scenes || {};
      if (cfg.matrixUrl) matrixUrl = cfg.matrixUrl;
    }
  } catch (e) {
    patterns = {};
    scenes = {};
  }

  /* Mapping advisor-keuze → catalogus tags (kleur groep / lay-out) */
  var GREY_TITLE_RE = /(grey|gray|grijs)/i;
  var DARK_GREY_TITLE_RE = /(medium|middle|dark|donker)\s*(grey|gray|grijs)/i;

  var steps = [
    {
      key: 'kleur',
      label: 'Kleur',
      type: 'color',
      multi: false,
      question: 'Welke kleurtint wil je op de vloer?',
      subtitle: 'Kies de sfeer. We tonen daarna alleen patronen die hierbij passen.',
      options: [
        {
          label: 'Licht eiken',
          description: 'Licht en fris',
          color: '#eadbc7',
          sceneKey: 'licht-eiken',
          catalogKleuren: ['licht', 'beige & zand'],
          titleExclude: DARK_GREY_TITLE_RE,
        },
        {
          label: 'Naturel / warm eiken',
          description: 'Neutraal tot warm',
          color: '#c49a6c',
          sceneKey: 'warm-eiken',
          catalogKleuren: ['eiken', 'bruin', 'beige & zand'],
        },
        {
          label: 'Donker eiken',
          description: 'Dieper en luxe',
          color: '#6e5647',
          sceneKey: 'donker-eiken',
          catalogKleuren: ['donker', 'bruin'],
        },
        {
          label: 'Eiken',
          description: 'Klassiek eiken',
          color: '#c4a574',
          sceneKey: 'eiken',
          catalogKleuren: ['eiken', 'bruin'],
        },
        {
          label: 'Licht grijs',
          description: 'Zacht en modern',
          color: '#d4d0cb',
          sceneKey: 'licht-grijs',
          catalogKleuren: ['grijs', 'licht'],
          lightGreySoft: true,
        },
        {
          label: 'Grijs',
          description: 'Koel en strak',
          color: '#9a948c',
          sceneKey: 'grijs',
          catalogKleuren: ['grijs'],
        },
      ],
    },
    {
      key: 'patroon',
      label: 'Patroon',
      type: 'pattern',
      multi: false,
      question: 'Kies het patroon dat bij jouw interieur past',
      subtitle: 'Alleen lay-outs die bij jouw kleur in het assortiment staan.',
      options: [
        { label: 'Visgraat', description: 'Klassiek en luxe', imageKey: 'visgraat', sceneKey: 'visgraat', soort: 'visgraat' },
        {
          label: 'Rechte plank',
          description: 'Rustig en tijdloos',
          imageKey: 'rechte-plank',
          sceneKey: 'rechte-plank',
          soort: 'rechte plank',
        },
        {
          label: 'Hongaarse punt',
          description: 'Strak en chique',
          imageKey: 'hongaarse-punt',
          sceneKey: 'hongaarse-punt',
          soort: 'hongaarse punt',
        },
        {
          label: 'Walvisgraat XL',
          description: 'Groot en uitgesproken',
          imageKey: 'walvisgraat-xl',
          sceneKey: 'walvisgraat-xl',
          soort: 'walvisgraat xl',
        },
        {
          label: 'Tegel (Betonlook)',
          description: 'Modern en strak',
          imageKey: 'tegellook',
          sceneKey: 'tegellook',
          soort: 'tegel',
        },
        {
          label: 'Weense punt',
          description: 'Grafisch en karaktervol',
          imageKey: 'weense-punt',
          sceneKey: 'weense-punt',
          soort: 'weense punt',
        },
      ],
    },
    {
      key: 'woonsituatie',
      label: 'Eisen',
      type: 'multi',
      multi: true,
      question: 'Waar moet jouw vloer tegen kunnen?',
      subtitle: 'Kruis alles aan wat klopt. Je mag meerdere opties kiezen.',
      options: [
        {
          label: 'Vloerverwarming aanwezig',
          description: 'Geschikt voor vloerverwarming',
          filter: { vvw: 'ja' },
          sceneKey: 'vloerverwarming',
        },
        {
          label: 'Appartement (10dB geluidsnorm)',
          description: 'Contactgeluidreductie vanaf 10 dB',
          sceneKey: 'stil-wonen',
        },
        {
          label: 'Intensief gebruik (Kinderen/Huisdieren)',
          description: 'Slijtlaag 0,55 mm of hoger',
          sceneKey: 'kinderen-huisdieren',
        },
        {
          label: 'Natte ruimtes (Badkamer)',
          description: 'Waterbestendig',
          filter: { waterbestendig: 'ja' },
          sceneKey: 'tegellook',
        },
      ],
    },
  ];

  var catalogRows = null;
  var catalogReady = false;
  var catalogLoading = false;
  var matrixScheduled = false;
  var MATRIX_DELAY_MS = isInline ? 200 : 800;
  var cascadePhotoCache = {};

  var els = {
    launcher: root.querySelector('[data-uf-fa-launcher]'),
    popup: root.querySelector('[data-uf-fa-popup]'),
    backdrop: root.querySelector('.uf-fa__backdrop'),
    wizard: root.querySelector('[data-uf-fa-wizard]'),
    meta: root.querySelector('[data-uf-fa-step-meta]'),
    fill: root.querySelector('[data-uf-fa-progress]'),
    title: root.querySelector('[data-uf-fa-title]'),
    question: root.querySelector('[data-uf-fa-question]'),
    headerSub: root.querySelector('[data-uf-fa-header-sub]'),
    headerTrack: root.querySelector('.uf-fa__header-track'),
    note: root.querySelector('[data-uf-fa-multi-note]'),
    choices: root.querySelector('[data-uf-fa-choices]'),
    back: root.querySelector('[data-uf-fa-back]'),
    next: root.querySelector('[data-uf-fa-next]'),
    closes: root.querySelectorAll('[data-uf-fa-close]'),
  };

  var stepIndex = 0;
  var answers = {};
  var open = isInline;
  var jsReady = false;

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/&/g, 'en')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function stepByKey(key) {
    for (var i = 0; i < steps.length; i += 1) {
      if (steps[i].key === key) return steps[i];
    }
    return null;
  }

  function normalizeTag(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function productMatchesKleur(row, kleurOpt) {
    if (!kleurOpt || !row) return false;
    var keys = kleurOpt.catalogKleuren || kleurOpt.kleurKeys || [];
    var hasKey = false;
    var i;
    for (i = 0; i < keys.length; i += 1) {
      if ((row.k || []).indexOf(normalizeTag(keys[i])) !== -1) {
        hasKey = true;
        break;
      }
    }
    if (!hasKey) return false;
    var title = String(row.t || '');
    /* Licht grijs: tag grijs altijd ok; tag licht alleen met grijze titel — geen harde reject */
    if (kleurOpt.lightGreySoft) {
      var inLicht = (row.k || []).indexOf('licht') !== -1;
      var inGrijs = (row.k || []).indexOf('grijs') !== -1;
      if (inGrijs) return true;
      if (inLicht && GREY_TITLE_RE.test(title)) return true;
      return false;
    }
    if (kleurOpt.titleInclude && !kleurOpt.titleInclude.test(title)) return false;
    if (kleurOpt.titleExclude && kleurOpt.titleExclude.test(title)) return false;
    return true;
  }

  function soortAliases(soort) {
    var want = normalizeTag(soort);
    if (!want) return [];
    var aliases = [want];
    /* Catalogus mist Lay-out: Weense punt — vaak als Hongaarse punt getagd */
    if (want === 'weense punt' && aliases.indexOf('hongaarse punt') === -1) {
      aliases.push('hongaarse punt');
    }
    return aliases;
  }

  function productMatchesSoort(row, soort) {
    if (!soort) return true;
    var aliases = soortAliases(soort);
    var s = row.s || [];
    for (var i = 0; i < aliases.length; i += 1) {
      if (s.indexOf(aliases[i]) !== -1) return true;
    }
    return false;
  }

  function selectedKleurOption() {
    var kleurStep = stepByKey('kleur');
    if (!kleurStep || typeof answers.kleur !== 'number') return null;
    return kleurStep.options[answers.kleur] || null;
  }

  function optionHasHits(step, option) {
    /* Patroon pas tonen als matrix er is — anders kan de gebruiker een lege snede kiezen */
    if (!catalogReady || !catalogRows || !catalogRows.length) {
      if (step.key === 'patroon') return false;
      return true;
    }
    if (step.key === 'woonsituatie') return true;
    if (step.key === 'kleur') {
      for (var i = 0; i < catalogRows.length; i += 1) {
        if (productMatchesKleur(catalogRows[i], option)) return true;
      }
      return false;
    }
    if (step.key === 'patroon') {
      var kleurOpt = selectedKleurOption();
      for (var j = 0; j < catalogRows.length; j += 1) {
        var row = catalogRows[j];
        if (kleurOpt && !productMatchesKleur(row, kleurOpt)) continue;
        if (productMatchesSoort(row, option.soort)) return true;
      }
      return false;
    }
    return true;
  }

  function visibleOptionEntries(step) {
    var out = [];
    step.options.forEach(function (option, index) {
      if (optionHasHits(step, option)) out.push({ option: option, index: index });
    });
    return out;
  }

  function pruneInvalidAnswers() {
    var kleurStep = stepByKey('kleur');
    if (kleurStep && typeof answers.kleur === 'number') {
      var kOpt = kleurStep.options[answers.kleur];
      if (!kOpt || !optionHasHits(kleurStep, kOpt)) delete answers.kleur;
    }
    var patroonStep = stepByKey('patroon');
    if (patroonStep && typeof answers.patroon === 'number') {
      var pOpt = patroonStep.options[answers.patroon];
      if (!pOpt || !optionHasHits(patroonStep, pOpt)) delete answers.patroon;
    }
  }

  function matrixEndpoint(page) {
    var url = new URL(matrixUrl, window.location.origin);
    url.searchParams.set('page', String(page || 1));
    return url.pathname + url.search;
  }

  function cascadeCacheKey(kleurOpt, soort) {
    var kleurPart = kleurOpt ? slugify(kleurOpt.label) : '_';
    var soortPart = soort ? normalizeTag(soort) : '_';
    return kleurPart + '::' + soortPart;
  }

  function findCascadeRow(kleurOpt, soort) {
    if (!catalogRows || !catalogRows.length) return null;
    var key = cascadeCacheKey(kleurOpt, soort);
    if (Object.prototype.hasOwnProperty.call(cascadePhotoCache, key)) {
      return cascadePhotoCache[key];
    }
    var found = null;
    for (var i = 0; i < catalogRows.length; i += 1) {
      var row = catalogRows[i];
      if (!row.i) continue;
      if (kleurOpt && !productMatchesKleur(row, kleurOpt)) continue;
      if (soort && !productMatchesSoort(row, soort)) continue;
      found = row;
      break;
    }
    cascadePhotoCache[key] = found;
    return found;
  }

  function cascadeImageForOption(step, option) {
    if (!catalogReady || !catalogRows || !catalogRows.length) return '';
    /* Alleen slide 1 (kleur) gebruikt catalogusfoto's; slide 2 blijft op vaste sfeerbeelden. */
    if (step.key === 'kleur') {
      var kleurRow = findCascadeRow(option, null);
      return kleurRow && kleurRow.i ? kleurRow.i : '';
    }
    return '';
  }

  function preloadCascadeImages() {
    var kleurStep = stepByKey('kleur');
    if (!kleurStep || !catalogRows) return;
    var urls = {};
    kleurStep.options.forEach(function (kleurOpt) {
      if (!optionHasHits(kleurStep, kleurOpt)) return;
      var kleurRow = findCascadeRow(kleurOpt, null);
      if (kleurRow && kleurRow.i) urls[kleurRow.i] = true;
    });
    Object.keys(urls).forEach(function (src) {
      var img = new Image();
      img.decoding = 'async';
      img.src = src;
    });
  }

  function loadCatalogMatrix() {
    if (catalogReady || catalogLoading) return Promise.resolve(catalogRows || []);
    catalogLoading = true;
    var cacheKey = 'uf_fa_matrix_v6';
    try {
      var cached = sessionStorage.getItem(cacheKey);
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && parsed.at && Date.now() - parsed.at < 6 * 60 * 60 * 1000 && parsed.rows) {
          catalogRows = parsed.rows;
          catalogReady = true;
          catalogLoading = false;
          cascadePhotoCache = {};
          pruneInvalidAnswers();
          preloadCascadeImages();
          return Promise.resolve(catalogRows);
        }
      }
    } catch (e) {
      /* ignore */
    }

    function fetchPage(page, acc) {
      return fetch(matrixEndpoint(page), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('matrix ' + res.status);
          return res.json();
        })
        .then(function (data) {
          var rows = (data.rows || []).map(function (row) {
            return {
              s: (row.s || []).map(normalizeTag).filter(Boolean),
              k: (row.k || []).map(normalizeTag).filter(Boolean),
              t: row.t || '',
              i: row.i || '',
            };
          });
          acc = acc.concat(rows);
          var pages = data.pages || 1;
          if (page < pages) return fetchPage(page + 1, acc);
          return acc;
        });
    }

    return fetchPage(1, [])
      .then(function (rows) {
        catalogRows = rows;
        catalogReady = true;
        catalogLoading = false;
        cascadePhotoCache = {};
        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ at: Date.now(), rows: rows }));
        } catch (e2) {
          /* ignore */
        }
        pruneInvalidAnswers();
        preloadCascadeImages();
        return rows;
      })
      .catch(function () {
        catalogRows = [];
        catalogReady = true;
        catalogLoading = false;
        return catalogRows;
      });
  }

  function scheduleCatalogMatrix() {
    if (matrixScheduled) return;
    matrixScheduled = true;
    setTimeout(function () {
      loadCatalogMatrix().then(function () {
        if (jsReady) render();
      });
    }, MATRIX_DELAY_MS);
  }

  function isDismissed() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var ts = parseInt(raw, 10);
      if (!isFinite(ts)) return false;
      return Date.now() - ts < storageDays * 24 * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* ignore */
    }
  }

  function selected(step, index) {
    return step.multi
      ? (answers[step.key] || []).indexOf(index) !== -1
      : answers[step.key] === index;
  }

  function answered(step) {
    return step.multi
      ? (answers[step.key] || []).length > 0
      : typeof answers[step.key] === 'number';
  }

  function select(step, index) {
    if (!step.multi) {
      answers[step.key] = index;
      if (step.key === 'kleur') {
        var patroonStep = stepByKey('patroon');
        if (patroonStep && typeof answers.patroon === 'number') {
          var pOpt = patroonStep.options[answers.patroon];
          if (!pOpt || !optionHasHits(patroonStep, pOpt)) delete answers.patroon;
        }
      }
      return;
    }
    var values = answers[step.key] || [];
    var existing = values.indexOf(index);
    if (existing >= 0) values.splice(existing, 1);
    else values.push(index);
    answers[step.key] = values;
  }

  /** Selecteer deze optie (bij multi: toevoegen, niet togglen) en ga door. */
  function confirmSelect(step, index) {
    if (!step.multi) {
      select(step, index);
    } else {
      var values = answers[step.key] ? answers[step.key].slice() : [];
      if (values.indexOf(index) === -1) values.push(index);
      answers[step.key] = values;
    }
  }

  function goNextFromStep() {
    var step = steps[stepIndex];
    if (!answered(step)) return;
    trackPopup('popup_step', {
      step: step.key,
      label: step.label,
      choice: choiceText(step),
    });
    if (stepIndex < steps.length - 1) {
      stepIndex += 1;
      render();
    } else {
      goToOrientation();
    }
  }

  function sceneUrl(option) {
    if (option.sceneKey && scenes[option.sceneKey]) return scenes[option.sceneKey];
    if (option.imageKey && scenes[option.imageKey]) return scenes[option.imageKey];
    if (option.imageKey && patterns[option.imageKey]) return patterns[option.imageKey];
    return '';
  }

  function escapeCssUrl(src) {
    return String(src || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'");
  }

  function optionMarkup(step, option) {
    var cascadeSrc = cascadeImageForOption(step, option);
    var src = cascadeSrc || sceneUrl(option);
    var media;
    if (src) {
      media =
        '<span class="uf-fa__tile-media' +
        (cascadeSrc ? ' uf-fa__tile-media--cascade' : '') +
        '" style="background-image:url(\'' +
        escapeCssUrl(src) +
        '\')" aria-hidden="true"></span>';
    } else if (option.color) {
      media =
        '<span class="uf-fa__tile-media" style="background:' +
        option.color +
        '" aria-hidden="true"></span>';
    } else {
      media = '<span class="uf-fa__tile-media uf-fa__tile-media--soft" aria-hidden="true"></span>';
    }
    return (
      media +
      '<span class="uf-fa__tile-copy"><strong>' +
      option.label +
      '</strong><small>' +
      option.description +
      '</small></span>'
    );
  }

  function render() {
    if (!jsReady) return;
    var step = steps[stepIndex];
    els.meta.textContent = stepIndex + 1 + ' van ' + steps.length + ' · ' + step.label;
    els.fill.style.width = ((stepIndex + 1) / steps.length) * 100 + '%';
    els.title.textContent = step.question;
    if (els.question) els.question.textContent = step.question;
    els.headerSub.textContent = step.subtitle;
    if (els.headerTrack) els.headerTrack.hidden = false;
    els.note.hidden = !step.multi;
    els.choices.innerHTML = '';

    var entries = visibleOptionEntries(step);
    var grid = document.createElement('div');
    grid.className = 'uf-fa__grid';
    if (!entries.length) {
      var empty = document.createElement('p');
      empty.className = 'uf-fa__multi-note';
      if (step.key === 'patroon' && (!catalogReady || catalogLoading)) {
        empty.textContent = 'Even geduld — we laden de passende patronen…';
      } else if (step.key === 'patroon') {
        empty.textContent =
          'Geen patronen gevonden voor deze kleur. Ga terug en kies een andere tint.';
      } else {
        empty.textContent = 'Geen opties beschikbaar in het assortiment.';
      }
      els.choices.appendChild(empty);
    } else {
      entries.forEach(function (entry) {
        var option = entry.option;
        var index = entry.index;
        var isOn = selected(step, index);
        var card = document.createElement('div');
        card.className =
          'uf-fa__tile uf-fa__tile--media' + (isOn ? ' is-selected' : '');
        card.setAttribute('role', 'group');
        card.setAttribute('aria-label', option.label);

        var hit = document.createElement('button');
        hit.type = 'button';
        hit.className = 'uf-fa__tile-hit';
        hit.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        hit.innerHTML = optionMarkup(step, option);
        hit.addEventListener('click', function () {
          select(step, index);
          render();
        });

        var confirmBtn = document.createElement('button');
        confirmBtn.type = 'button';
        confirmBtn.className =
          'uf-fa__tile-confirm' + (isOn ? ' is-ready' : '');
        confirmBtn.textContent = isOn ? 'Bevestig' : 'Kies';
        confirmBtn.setAttribute(
          'aria-label',
          (isOn ? 'Bevestig ' : 'Kies ') + option.label + ' en ga verder'
        );
        confirmBtn.addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          confirmSelect(step, index);
          goNextFromStep();
        });

        var copyEl = hit.querySelector('.uf-fa__tile-copy');
        if (isInline && copyEl) {
          copyEl.appendChild(confirmBtn);
        } else {
          card.appendChild(confirmBtn);
        }
        card.appendChild(hit);
        grid.appendChild(card);
      });
      els.choices.appendChild(grid);
    }

    els.back.style.visibility = stepIndex === 0 ? 'hidden' : 'visible';
    els.next.disabled = !answered(step) || !entries.length;
    els.next.textContent = stepIndex === steps.length - 1 ? 'Naar oriëntatie' : 'Volgende';
  }

  function answerLabels() {
    return steps.reduce(function (acc, step) {
      var value = answers[step.key];
      if (step.multi) {
        (value || []).forEach(function (index) {
          acc.push(step.options[index].label);
        });
      } else if (typeof value === 'number') {
        acc.push(step.options[value].label);
      }
      return acc;
    }, []);
  }

  function buildOrientationUrl() {
    var url;
    try {
      var base = new URL(orientBase, window.location.origin);
      var current = new URL(window.location.href);
      var samePage =
        current.pathname === base.pathname &&
        (current.searchParams.get('view') || '') === (base.searchParams.get('view') || '');
      url = samePage ? current : base;
    } catch (e) {
      url = new URL('/collections/pvc?view=orientatieruimte', window.location.origin);
    }
    if (!url.searchParams.get('view') && url.pathname.indexOf('/collections/') === 0) {
      url.searchParams.set('view', 'orientatieruimte');
    }
    ['advisor', 'soort', 'patroon', 'kleur_pref', 'eigenschappen', 'vvw', 'waterbestendig'].forEach(function (key) {
      url.searchParams.delete(key);
    });
    url.searchParams.set('advisor', '1');

    steps.forEach(function (step) {
      var value = answers[step.key];
      if (step.key === 'patroon' && typeof value === 'number') {
        var soort = step.options[value].soort;
        if (soort) url.searchParams.set('soort', soort);
        url.searchParams.set('patroon', slugify(step.options[value].label));
      } else if (step.key === 'kleur' && typeof value === 'number') {
        url.searchParams.set('kleur_pref', slugify(step.options[value].label));
      } else if (step.key === 'woonsituatie') {
        var selectedValues = (value || []).map(function (index) {
          return slugify(step.options[index].label);
        });
        if (selectedValues.length) {
          url.searchParams.set('eigenschappen', selectedValues.join(','));
        }
        (value || []).forEach(function (index) {
          var f = step.options[index].filter;
          if (f) {
            Object.keys(f).forEach(function (k) {
              url.searchParams.set(k, f[k]);
            });
          }
        });
      }
    });

    try {
      sessionStorage.setItem(
        'uf_floor_advisor_profile',
        JSON.stringify({
          labels: answerLabels(),
          at: Date.now(),
        })
      );
    } catch (e2) {
      /* ignore */
    }

    return url.pathname + url.search + url.hash;
  }

  function optionIndexBySlug(step, slug) {
    var want = slugify(slug);
    if (!want) return -1;
    for (var i = 0; i < step.options.length; i += 1) {
      if (slugify(step.options[i].label) === want) return i;
    }
    return -1;
  }

  function restoreAnswersFromPage() {
    var q;
    try {
      q = new URL(window.location.href).searchParams;
    } catch (e) {
      return;
    }
    var next = {};
    var patroonStep = stepByKey('patroon');
    var kleurStep = stepByKey('kleur');
    var eisenStep = stepByKey('woonsituatie');

    if (patroonStep) {
      var patroonIndex = optionIndexBySlug(patroonStep, q.get('patroon') || '');
      if (patroonIndex < 0 && q.get('soort')) {
        var soort = slugify(q.get('soort'));
        for (var i = 0; i < patroonStep.options.length; i += 1) {
          if (slugify(patroonStep.options[i].soort) === soort) {
            patroonIndex = i;
            break;
          }
        }
      }
      if (patroonIndex >= 0) next.patroon = patroonIndex;
    }

    if (kleurStep) {
      var kleurIndex = optionIndexBySlug(kleurStep, q.get('kleur_pref') || '');
      if (kleurIndex >= 0) next.kleur = kleurIndex;
    }

    if (eisenStep) {
      var eigs = (q.get('eigenschappen') || '')
        .split(',')
        .map(function (part) {
          return slugify(part);
        })
        .filter(Boolean);
      if (eigs.length) {
        var picked = [];
        eisenStep.options.forEach(function (option, index) {
          if (eigs.indexOf(slugify(option.label)) !== -1) picked.push(index);
        });
        if (picked.length) next.woonsituatie = picked;
      }
    }

    if (next.patroon == null && next.kleur == null && !next.woonsituatie) return;
    answers = next;
    pruneInvalidAnswers();
  }

  function goToOrientation() {
    pruneInvalidAnswers();
    var patroonStep = stepByKey('patroon');
    if (patroonStep && typeof answers.patroon === 'number') {
      var pOpt = patroonStep.options[answers.patroon];
      if (!pOpt || !optionHasHits(patroonStep, pOpt)) {
        delete answers.patroon;
        stepIndex = steps.indexOf(patroonStep);
        if (stepIndex < 0) stepIndex = 1;
        render();
        return;
      }
    }
    var href = buildOrientationUrl();
    trackPopup('popup_cta', {
      choices: answerLabels().join(' · ').slice(0, 180),
    });
    markDismissed();
    window.location.assign(href);
  }

  function choiceText(step) {
    var value = answers[step.key];
    if (step.multi) {
      return (value || [])
        .map(function (index) {
          return step.options[index].label;
        })
        .join(', ');
    }
    if (typeof value === 'number') return step.options[value].label;
    return '';
  }

  function trackPopup(name, props) {
    var tries = 0;
    function send() {
      if (typeof window.ufTrack === 'function') {
        window.ufTrack(name, props);
        return;
      }
      tries += 1;
      if (tries > 20) return;
      setTimeout(send, 250);
    }
    send();
  }

  function setOpen(nextOpen, opts) {
    opts = opts || {};
    if (isInline) {
      open = true;
      if (els.popup) els.popup.hidden = false;
      ensureReady();
      render();
      return;
    }
    var wasOpen = open;
    open = !!nextOpen;
    if (els.popup) els.popup.hidden = !open;
    if (els.backdrop) els.backdrop.hidden = !open;
    if (els.launcher) {
      els.launcher.setAttribute('aria-expanded', open ? 'true' : 'false');
      els.launcher.classList.toggle('is-open', open);
    }
    document.documentElement.classList.toggle('uf-fa-open', open);
    if (!open && opts.dismiss) markDismissed();
    if (open && !wasOpen) {
      trackPopup('popup_open', { source: opts.source || 'knop', step: steps[stepIndex].label });
    }
    if (!open && wasOpen) {
      trackPopup('popup_close', { source: opts.source || 'sluiten', step: steps[stepIndex].label });
    }
    if (open) {
      render();
      try {
        els.popup.focus({ preventScroll: true });
      } catch (e) {
        /* ignore */
      }
    }
  }

  function ensureReady() {
    if (jsReady) {
      render();
      return;
    }
    jsReady = true;
    render();
    scheduleCatalogMatrix();
  }

  if (els.launcher) {
    els.launcher.addEventListener('click', function () {
      ensureReady();
      setOpen(!open, { dismiss: false, source: 'knop' });
    });
  }

  els.closes.forEach(function (btn) {
    btn.addEventListener('click', function () {
      setOpen(false, { dismiss: true, source: 'kruis' });
    });
  });

  els.back.addEventListener('click', function () {
    if (stepIndex > 0) {
      stepIndex -= 1;
      if (els.wizard) els.wizard.hidden = false;
      render();
    }
  });

  els.next.addEventListener('click', function () {
    goNextFromStep();
  });

  document.addEventListener('click', function (ev) {
    var trigger = ev.target && ev.target.closest ? ev.target.closest('[data-uf-fa-open]') : null;
    if (!trigger) return;
    ensureReady();
    restoreAnswersFromPage();
    stepIndex = 0;
    if (els.wizard) els.wizard.hidden = false;
    setOpen(true, { dismiss: false, source: 'keuze-tool' });
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && open && !isInline) {
      setOpen(false, { dismiss: true, source: 'escape' });
    }
  });

  // Cascade-foto's + matrix: starten 2s na page load (niet blokkerend).
  scheduleCatalogMatrix();

  // Inline: wizard direct zichtbaar. Modal/tool: geen auto-open.
  if (isInline) {
    ensureReady();
    setOpen(true, { source: 'inline' });
  }
})();
